import Vue from "vue";
import SideComponent from "@/models/shared/side.component";
import { ActivityDto, ActivityAreaDto } from "@/server/app.dtos";

export const LayoutServiceBus = new Vue({
  methods: {
    openSideMenuCreatingActivity(area: ActivityAreaDto): void {
      const comp = new SideComponent();
      comp.title = "CreateActivitySideMenuComponent";
      comp.args = {
        activityArea: area
      };
      this.openSideMenu(comp);
    },
    openSideMenuPreviewActivity(activity: ActivityDto): void {
      const comp = new SideComponent();
      comp.title = "DetailActivitySideMenuComponent";
      comp.args = {
        activity: activity
      };
      this.openSideMenu(comp);
    },
    openSideMenu(sideComponent: SideComponent): void {
      this.$emit("openSideMenu", sideComponent);
    },
    closeSideMenu(): void {
      this.$emit("closeSideMenu");
    },
    openNotifications(): void {
      this.$emit("openNotifications");
    },
    closeNotifications(): void {
      this.$emit("closeNotifications");
    }
  }
});
